import { render } from "./CmpInformacionCliente.vue?vue&type=template&id=cd6323a2&scoped=true"
import script from "./CmpInformacionCliente.vue?vue&type=script&lang=js"
export * from "./CmpInformacionCliente.vue?vue&type=script&lang=js"

import "./CmpInformacionCliente.vue?vue&type=style&index=0&id=cd6323a2&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd6323a2"]])

export default __exports__